import { Command } from 'commands/Commands';

export class ChangeCustomUrl extends Command {
  type: string = 'Member.ChangeCustomUrl';
  priority = 100;
  constructor(payload: string, id: string) {
    super(payload, id);
  }
}
